import React from 'react';
import { connect } from 'react-redux';
import ComboBox from '../../../../../components/ComboBox';
import DatePicker from '../../../../../components/DatePicker';
import './ReferenceDocumentFilter.scss';
import moment from 'moment';

import BaseComponent from '../../../../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure

class ReferenceDocumentFilter extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedMarket:
        props.selectedFilters && props.selectedFilters.market
          ? props.selectedFilters.market
          : null,
      selectedDocumentType:
        props.selectedFilters && props.selectedFilters.documentType
          ? props.selectedFilters.documentType
          : null,
      startDate:
        props.selectedFilters && props.selectedFilters.startDate 
          ? props.selectedFilters.startDate
          : null,
      endDate:
        props.selectedFilters && props.selectedFilters.endDate 
          ? props.selectedFilters.endDate
          : null,
    };
  }
  
  componentDidUpdate(prevProps) {
    const nextProps = this.props;
    if (
      nextProps.selectedFilters != prevProps.selectedFilters &&
      nextProps.selectedFilters
    ) {
      this.setState({
        selectedMarket:
          nextProps.selectedFilters && nextProps.selectedFilters.market
            ? nextProps.selectedFilters.market
            : null,
        selectedDocumentType:
          nextProps.selectedFilters && nextProps.selectedFilters.documentType
            ? nextProps.selectedFilters.documentType
            : null,
        startDate:
          nextProps.selectedFilters && nextProps.selectedFilters.startDate 
            ? nextProps.selectedFilters.startDate
            : null,
        endDate:
          nextProps.selectedFilters && nextProps.selectedFilters.endDate 
            ? nextProps.selectedFilters.endDate
            : null,
      });
    }
  }

  handleCloseMenu() {
    if (this.state.menu) {
      this.setState({ menu: null, displayMenu: '' });
    }
  }

  handleMarketChange(type, option) {
    const { handleMarketSelection } = this.props;
    if (handleMarketSelection) {
      this.setState({
        selectedMarket: type,
      });
      handleMarketSelection(type == 'allMarkets' ? null : type);
    }
  }

  handleDocumentTypeChange(type, option) {
    const { handleDocumentTypeSelection } = this.props;
    if (handleDocumentTypeSelection) {
      this.setState({
        selectedDocumentType: type,
      });
      handleDocumentTypeSelection(type == 'allDocumentTypes' ? null : type);
    }
  }

  handleStartDateSelection(date) {
    const { handleStartDateSelection } = this.props;
    if(handleStartDateSelection){
      handleStartDateSelection(date);
      this.setState({ 
        startDate: date,
      });
    }
  }

  handleEndDateSelection(date) {
    const { handleEndDateSelection } = this.props;
    if (handleEndDateSelection) {
      handleEndDateSelection(date);
      this.setState({ 
        endDate: date,
      });
    }  
  }

  render() {
    let { selectedDocumentType, selectedMarket } = this.state;
    let documentTypeSelector; 
    let documentTypeList = [
      { type: 'allDocumentTypes', name: '-- All Document Types --' },
      { type: 'pdf', name: 'PDF', documentType: 'pdf' },
      { type: 'jpg', name: 'JPG/PNG', documentType: 'jpg' },
      { type: 'xls', name: 'XLS/XLSX', documentType: 'xls' },
      { type: 'doc', name: 'DOC/DOCX', documentType: 'doc' },
      { type: 'other', name: 'OTHER', documentType: 'other' },
      { type: 'mp4', name: 'MP4/MOV', documentType: 'video' },
    ];

    let currentDocumentType = selectedDocumentType
      ? documentTypeList.filter(subType => {
        return subType.type.toString() == selectedDocumentType;
      })
      : [];

    if (currentDocumentType.length == 0) {
      currentDocumentType = documentTypeList[0];
    } else {
      currentDocumentType = currentDocumentType[0];
    }

    documentTypeSelector = (
      <ComboBox
        key={'documentTypePicker'}
        id={'documentTypePicker'}
        options={documentTypeList}
        currentOption={currentDocumentType}
        hasBorder={false}
        underlined={false}
        width={238}
        height={31}
        displayFontStyle={{ fontSize: '14px' }}
        handleSelection={this.handleDocumentTypeChange}
      />
    );

    let marketsList = [
      { type: 'allMarkets', name: '-- All Markets --' },
    ];

    if(this.props.markets){
      this.props.markets.forEach(market => {
        let marketOption = {
          type: market.id,
          name: market.name,
          market: market,
        };
        marketsList.push(marketOption);
      }); 
    }

    let currentSelectedMarket = selectedMarket
      ? marketsList.filter(market => {
        return market.type.toString() == selectedMarket;
      })
      : [];

    if (currentSelectedMarket.length == 0) {
      currentSelectedMarket = marketsList[0];
    } else {
      currentSelectedMarket = currentSelectedMarket[0];
    }

    marketsList.sort((c1, c2) => {
      if (c1.name < c2.name) {
        return -1;
      } else if (c1.name > c2.name) {
        return 1;
      } else {
        return 0;
      }
    });

    let marketSelector = (
      <ComboBox
        key={'marketPicker'}    
        id={'marketPicker'}
        options={marketsList}
        currentOption={currentSelectedMarket}
        hasBorder={false}
        underlined={false}
        height={31}
        width={238}
        menuHeight={120}
        displayFontStyle={{ fontSize: '14px' }}
        handleSelection={this.handleMarketChange}
      />
    );

    let startDate = (
      <div className="reference-docs-start-date-selector">
        <div className='start-date-label'>FROM</div>
        <div className="date-picker-container">
          <DatePicker
            selected={this.state.startDate}
            handleDateSelection={this.handleStartDateSelection}
            minDate={moment().startOf('year').subtract(1, 'y')}
            maxDate={moment()}
            placeHolderText={'MM/DD/YYYY'}
            width={92}/>
        </div>
      </div>
    );

    let endDate = (
      <div className="reference-docs-end-date-selector">
        <div className='end-date-label'>TO</div>
        <div className="date-picker-container">
          <DatePicker
            selected={this.state.endDate}
            handleDateSelection={this.handleEndDateSelection}
            minDate={this.state.startDate ? this.state.startDate :
              moment().startOf('year').subtract(1, 'y')
            }
            maxDate={moment()}
            placeHolderText={'MM/DD/YYYY'}
            width={92}/>
        </div>
      </div>
    );

    return (
      <div className="reference-docs-filters">
        <div className='reference-docs-markets-container'>
          <div className="reference-docs-filter-selector-label">{this.textMap.market.toUpperCase()}</div>
          <div className="reference-docs-filter-selector-container">{marketSelector}</div>
        </div>
        <div className='reference-docs-document-types-container'>
          <div className="reference-docs-filter-selector-label">{this.textMap.documentType.toUpperCase()}</div>
          <div className="reference-docs-filter-selector-container">{documentTypeSelector}</div>
        </div>
        <div className='reference-docs-date-selector-container'>
          {startDate}
          {endDate}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  
  return {
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
    activitiesList: state.activityLogs.activitiesList,
  };
};

export default connect(mapStateToProps)(ReferenceDocumentFilter);



// WEBPACK FOOTER //
// ./src/containers/ReferenceDocumentsLibrary/ReferenceDocumentSearchFilter/ReferenceDocumentFilterPopout/ReferenceDocumentFilter/index.js